





















import { Component, Vue, Prop } from 'vue-property-decorator';
import enter_into from '../../../assets/image/enter_into.png';

// 声明组件*****************
@Component({
  components: {

  }
})
export default class NewForm extends Vue {
  // props
  @Prop({ default:()=>({}) }, Object) 
  private data!: object
  // 属性*****************
  private enter_into: string = enter_into;
 

  // 方法*****************
    private submit(): any{
        return this.$validator.validateAll().then((result: boolean) => {
            if(result){
                this.$emit('submit',this.data);
            }else{
                this['$message']({
                    value:this['errors'].items[0].msg
                })
            }
        });
    }
}
